import { useLanguage } from '../../i18n';
import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.copyright}>
            Copyright {currentYear} – <span className={styles.name}>Fernando Olea</span>
          </p>

          <div className={styles.aiBadge}>
            <span className={styles.badgeIcon}>🤖</span>
            <span className={styles.badgeText}>
              {t.footer.developedWith}{' '}
              <a
                href="https://claude.ai/code"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.badgeLink}
              >
                Claude Code
              </a>
              {' '}{t.footer.and}{' '}
              <a
                href="https://cursor.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.badgeLink}
              >
                Cursor
              </a>
            </span>
          </div>
        </div>

        <div className={styles.glowLine} />
      </div>
    </footer>
  );
}
